module.exports = __webpack_public_path__ + "img/P34920580Fcamera.3a4bc838.jpg";